import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ModelSelectorComponent } from '../model-selector/model-selector.component';

@Component({
  selector: 'app-chat-header',
  standalone: true,
  imports: [ModelSelectorComponent, CommonModule],
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.scss'],
})
export class ChatHeaderComponent {
  @Input() title = '';
  @Input() chatType = 'chat';
  @Input() modelSelector: boolean | null = false;
  @Output() modelSelected = new EventEmitter<string>();

  onModelSelected(model: string): void {
    this.modelSelected.emit(model);
  }
}
